import { render } from "./WorksComponent.vue?vue&type=template&id=75edf60b"
import script from "./WorksComponent.vue?vue&type=script&lang=js"
export * from "./WorksComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../.yarn/__virtual__/vue-loader-virtual-5e85c868fe/4/.yarn/berry/cache/vue-loader-npm-17.4.2-00674d01e5-10c0.zip/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__